import "./style.css";
import { useTranslation } from "react-i18next";

const BusinessMeetAssistCancellationPolicy = ({
    className
}) => {
    const { t } = useTranslation();
    return (
        <div className={className}>
            <div className="d-none d-md-block">
                <table className="w-100" id="cancellationTable">
                    <tr>
                        <td colSpan={5} className="bg-gold-light2">
                            <p
                                className="m-0 fw-700"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.business.meetAssitCancellationPolicy.title") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td className="bg-56273A">
                            <p className="fw-700 my-0 mx-2 text-gold">{t("componentTnc.business.meetAssitCancellationPolicy.header.H1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-E0D8DA">
                            <p
                                className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T1"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            rowSpan={2}
                            className="bg-CAC3C6"
                        >
                            <p
                                className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R2.T1"),
                                }}
                            ></p>
                        </td>
                        <td
                            colSpan={4}
                            className="bg-F1F1F2 border-top-white"
                        >
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R2.T2"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={4}
                            className="bg-F9F9F9 border-top-white"
                        >
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R2.T3"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={5}
                            className="bg-F6EEDC border-top-white"
                        >
                            <p className="my-0 mx-5"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R3.T1"),
                                }}
                            ></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="d-block d-md-none" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <div style={{ minWidth: '560px' }}>
                <table className="w-100" id="cancellationTable">
                    <tr>
                        <td colSpan={5} className="bg-gold-light2">
                            <p
                                className="m-0 fw-700"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.business.meetAssitCancellationPolicy.title") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td className="bg-56273A">
                            <p className="fw-700 my-0 mx-2 text-gold">{t("componentTnc.business.meetAssitCancellationPolicy.header.H1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.header.H5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-E0D8DA">
                            <p
                                className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T1"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R1.T5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            rowSpan={2}
                            className="bg-CAC3C6"
                        >
                            <p
                                className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R2.T1"),
                                }}
                            ></p>
                        </td>
                        <td
                            colSpan={4}
                            className="bg-F1F1F2 border-top-white"
                        >
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R2.T2"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={4}
                            className="bg-F9F9F9 border-top-white"
                        >
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R2.T3"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={5}
                            className="bg-F6EEDC border-top-white"
                        >
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.meetAssitCancellationPolicy.content.R3.T1"),
                                }}
                            ></p>
                        </td>
                    </tr>
                </table>
                </div>
            </div>
        </div>
    );
};

export default BusinessMeetAssistCancellationPolicy;
